import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {API_BASE_URL} from "./constants";

// Define the async thunk to fetch products from the API
export const fetchProducts = createAsyncThunk(
    'product/fetchProducts',
    async () => {
        const currentLanguage = localStorage.getItem('i18nextLng') ?? 'en';

        let transformedLocale;
        if (currentLanguage.startsWith('en')) {
            transformedLocale = 'en';
        } else if (currentLanguage.startsWith('fr')) {
            transformedLocale = 'fr';
        } else if (currentLanguage.startsWith('sv')) {
            transformedLocale = 'sv';
        } else if (currentLanguage.startsWith('fi')) {
            transformedLocale = 'fi';
        } else if (currentLanguage.startsWith('nl')) {
            transformedLocale = 'nl';
        } else if (currentLanguage.startsWith('dk') || currentLanguage.startsWith('da')) {
            transformedLocale = 'da';
        } else if (currentLanguage.startsWith('no')) {
            transformedLocale = 'nb';
        } else if (currentLanguage.startsWith('es')) {
            transformedLocale = 'es';
        }
        else {
            transformedLocale = currentLanguage ?? 'en';
        }
        const response = await fetch(`${API_BASE_URL}/products?locale=${transformedLocale}`);
        const data = await response.json();
        function moveAttributesToTopLevel(items) {
            return items.map(item => {
                const newItem = JSON.parse(JSON.stringify(item));
                newItem.id = newItem.id.toString();
                const attributes = newItem.attributes;
                delete newItem.attributes;
                return { ...attributes, ...newItem };
            });
        }

        return moveAttributesToTopLevel(data.data);
    }
);


// Define the product slice with the initial state and the setProducts reducer
const productSlice = createSlice({
    name: 'product',
    initialState: {
        products: [],
    },
    reducers: {
        setProducts(state, action) {
            state.products = action.payload;
        },
    },
    extraReducers: (builder) => {
        // TODO: Cover loading and error states
        builder.addCase(fetchProducts.fulfilled, (state, action) => {
            state.products = action.payload;
        });
    },
});

export const { setProducts } = productSlice.actions;
export default productSlice.reducer;
